import styled from 'styled-components';
import React from 'react';
import { getPublicAsset } from 'base/shared/Utils';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  background-color: #f0f0f0;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 24px;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }
`;

const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: 500;
  color: #111827;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    max-width: 300px;
    align-items: center;
  }
`;

const BadgeImageContainer = styled.a`
  display: block;
  width: 120px;
  height: 45px;
  border-radius: 8px;
  background-image: url('${(props) => props.$imageUrl}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition:
    transform 0.2s,
    opacity 0.2s;
  &:hover {
    transform: translateY(-2px);
    opacity: 0.9;
  }
  @media (max-width: 768px) {
    width: 140px;
    height: 50px;
  }
`;

export default function AppDownloadBanner() {
  return (
    <Container>
      <Title>{translate('v2.home.appDownloadBanner.title')}</Title>{' '}
      <ButtonsContainer>
        <BadgeImageContainer
          href="https://play.google.com/store/apps/details?id=es.inmovens.badi&hl=en&pli=1"
          target="_blank"
          rel="noopener noreferrer"
          $imageUrl={getPublicAsset('v2/images/google-play.png')}
          aria-label="Get it on Google Play"
        />
        <BadgeImageContainer
          href="https://apps.apple.com/us/app/badi-rooms-for-rent/id1008653746"
          target="_blank"
          rel="noopener noreferrer"
          $imageUrl={getPublicAsset('v2/images/app-store.png')}
          aria-label="Download on the App Store"
        />
      </ButtonsContainer>
    </Container>
  );
}
